export const statsData = [
  { number: '+3500', label: 'عميل راضٍ' },
  { number: '+450', label: 'تطبيق ناجح' },
  { number: '+250', label: 'مطوّر ومصمم' },
  { number: '+50000', label: 'تحميل شهري' },
];

export const featuresData = [
  {
    icon: 'ri-smartphone-line',
    title: 'تصميم واجهات تطبيقات UX/UI',
    description: 'شاشات عصرية سهلة الاستخدام تزيد التفاعل والاحتفاظ بالمستخدمين',
  },
  {
    icon: 'ri-code-s-slash-line',
    title: 'برمجة أصلية ومختلطة',
    description: 'تطوير بـ iOS و Android و Flutter حسب احتياج مشروعك وأداء التطبيق',
  },
  {
    icon: 'ri-notification-3-line',
    title: 'إشعارات فورية Push',
    description: 'تواصل لحظي مع مستخدميك لزيادة العودة والمبيعات',
  },
  {
    icon: 'ri-secure-payment-line',
    title: 'دفع إلكتروني آمن',
    description: 'ربط بوابات الدفع المحلية والعالمية داخل التطبيق',
  },
  {
    icon: 'ri-dashboard-3-line',
    title: 'لوحة تحكم للتطبيق',
    description: 'إدارة المحتوى، الطلبات، والمستخدمين من لوحة واحدة',
  },
  {
    icon: 'ri-cloud-line',
    title: 'API وربط أنظمة',
    description: 'تكامل مع ERP، المتاجر، والخدمات الخارجية بسلاسة',
  },
  {
    icon: 'ri-store-2-line',
    title: 'نشر على المتاجر',
    description: 'إعداد الحسابات ورفع التطبيق على App Store و Google Play',
  },
  {
    icon: 'ri-customer-service-2-line',
    title: 'دعم بعد الإطلاق',
    description: 'صيانة، تحديثات، وتحسينات مستمرة بعد التسليم',
  },
];

export const workStepsData = [
  {
    step: '01',
    title: 'تحليل الفكرة والجمهور',
    description: 'نحدد أهداف التطبيق، المستخدم المستهدف، والميزات الأساسية لخارطة طريق واضحة.',
  },
  {
    step: '02',
    title: 'تصميم تجربة وواجهات',
    description: 'نبني Wireframes و Prototype تفاعلي يوضح رحلة المستخدم قبل البرمجة.',
  },
  {
    step: '03',
    title: 'البرمجة والتطوير',
    description: 'نطوّر التطبيق بأحدث التقنيات مع اختبارات مستمرة لضمان الجودة.',
  },
  {
    step: '04',
    title: 'الاختبار والأداء',
    description: 'اختبار على أجهزة متعددة وتحسين السرعة والاستقرار قبل الإطلاق.',
  },
  {
    step: '05',
    title: 'النشر والدعم',
    description: 'رفع التطبيق على المتاجر ومتابعة التحديثات والدعم الفني.',
  },
];

export const servicesData = [
  {
    icon: 'ri-smartphone-line',
    title: 'تطبيقات iOS و Android',
    description: 'تطبيقات أصلية أو متعددة المنصات بأداء عالٍ وتجربة سلسة',
  },
  {
    icon: 'ri-store-3-line',
    title: 'تطبيقات متاجر إلكترونية',
    description: 'بيع المنتجات والخدمات عبر تطبيق مخصص لعلامتك التجارية',
  },
  {
    icon: 'ri-car-line',
    title: 'تطبيقات توصيل وخدمات',
    description: 'تتبع الطلبات، الخرائط، والدفع — حلول جاهزة قابلة للتخصيص',
  },
  {
    icon: 'ri-hospital-line',
    title: 'تطبيقات حجز ومواعيد',
    description: 'حجز المواعيد، التذكيرات، وإدارة العملاء في قطاعات متعددة',
  },
  {
    icon: 'ri-palette-line',
    title: 'إعادة تصميم تطبيق قائم',
    description: 'تحديث الواجهات وتحسين تجربة المستخدم لتطبيقك الحالي',
  },
  {
    icon: 'ri-tools-line',
    title: 'صيانة وتطوير تطبيقات',
    description: 'إصلاح الأعطال، إضافة ميزات، ومواكبة تحديثات أنظمة التشغيل',
  },
];

/** صور من معرض أعمال أوامر الشبكة — aait.sa */
const AAIT_UPLOADS = 'https://aait.sa/wp-content/uploads/2025/02';

export const portfolioData = [
  {
    title: 'تطبيق Arrive',
    category: 'توصيل وخدمات',
    description: 'توصيل ركاب — تطبيق تاكسي ذكي',
    image: `${AAIT_UPLOADS}/Arrive-screen.webp`,
    imageBg: 'from-amber-500/25 via-amber-950/30 to-slate-900',
  },
  {
    title: 'تطبيق خيرات',
    category: 'متجر إلكتروني',
    description: 'متجر إلكتروني مع دفع وشحن',
    image: `${AAIT_UPLOADS}/%d8%ae%d9%8a%d8%b1%d8%a7%d8%aa.webp`,
    imageBg: 'from-violet-500/20 via-indigo-950/40 to-slate-900',
  },
  {
    title: 'تطبيق Ekceer',
    category: 'حجوزات',
    description: 'حجز خدمات صحية وتجميلية',
    image: `${AAIT_UPLOADS}/Exceer.webp`,
    imageBg: 'from-teal-500/25 via-teal-950/35 to-slate-900',
  },
  {
    title: 'تطبيق Broker',
    category: 'تطبيق شركة',
    description: 'إدارة عروض وطلبات عقارية',
    image: `${AAIT_UPLOADS}/Broker.webp`,
    imageBg: 'from-blue-500/20 via-slate-900 to-indigo-950/50',
  },
];

export const whyAAITData = [
  {
    icon: 'ri-lightbulb-flash-line',
    title: 'خبرة في التطبيقات',
    description: 'مئات التطبيقات المنشورة في السوق السعودي والخليجي',
  },
  {
    icon: 'ri-award-line',
    title: 'جودة عالية',
    description: 'معايير صارمة في التصميم والبرمجة والاختبار قبل التسليم',
  },
  {
    icon: 'ri-time-line',
    title: 'التزام بالمواعيد',
    description: 'جدول زمني واضح ومتابعة دورية لكل مرحلة من المشروع',
  },
  {
    icon: 'ri-store-line',
    title: 'نشر على المتاجر',
    description: 'نساعدك في إعداد الحسابات ورفع التطبيق بنجاح',
  },
  {
    icon: 'ri-message-3-line',
    title: 'دعم مستمر',
    description: 'فريق تقني جاهز للرد والصيانة بعد الإطلاق',
  },
];

export const testimonialsData = [
  {
    name: 'خالد الشمري',
    role: 'مؤسس تطبيق توصيل',
    content:
      'أوامر الشبكة طوّرت تطبيقنا من الصفر. التصميم احترافي والأداء ممتاز، والعملاء يستخدمونه يوميًا بسلاسة.',
    rating: 5,
  },
  {
    name: 'نورة الحربي',
    role: 'مديرة تطبيق حجوزات',
    content:
      'من أول اجتماع حتى النشر على المتاجر، كل شيء كان منظمًا. الفريق يفهم احتياج السوق السعودي.',
    rating: 5,
  },
  {
    name: 'ماجد الدوسري',
    role: 'صاحب متجر إلكتروني',
    content:
      'تطبيق المتجر زاد مبيعاتنا بشكل ملحوظ. الدعم بعد الإطلاق سريع ومتعاون. أنصح بالتعامل معهم.',
    rating: 5,
  },
];

export const navLinks = [
  { label: 'الرئيسية', href: '#hero' },
  { label: 'المميزات', href: '#features' },
  { label: 'مراحل العمل', href: '#steps' },
  { label: 'أعمالنا', href: '#portfolio' },
  { label: 'الأسئلة الشائعة', href: '#faq' },
  { label: 'تواصل معنا', href: '#cta' },
];

export const faqData = [
  {
    question: 'كم تستغرق مدة تصميم وبرمجة تطبيق؟',
    answer:
      'تتراوح المدة بين 6 إلى 16 أسبوعًا حسب عدد الشاشات، التكاملات، ومنصات النشر (iOS فقط، Android فقط، أو الاثنين).',
  },
  {
    question: 'هل تطورون تطبيقات iOS و Android معًا؟',
    answer:
      'نعم، نطوّر للمنصتين باستخدام تقنيات أصلية أو Flutter حسب متطلبات الأداء والميزانية.',
  },
  {
    question: 'هل تساعدون في رفع التطبيق على المتاجر؟',
    answer:
      'نعم، نجهّز الحسابات، الأصول، والوصف ونرفع التطبيق على App Store و Google Play.',
  },
  {
    question: 'هل يمكن ربط التطبيق بموقع أو نظام موجود؟',
    answer:
      'بالتأكيد، نبني واجهات API ونربط التطبيق بموقعك، ERP، أو أي نظام خارجي.',
  },
];
